import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import '../assets/css/Home.css'; // Make sure to create and link this CSS file
import image from '../assets/images/security-image.jpg'; // Update the path as necessary
import facebookIcon from '../assets/images/icon_facebook_f3a95533ef.svg';
import twitterIcon from '../assets/images/icon_twitter_5310b73e96.svg';
import linkedinIcon from '../assets/images/icon_linkedin_67007bf547.svg';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick'; // Import react-slick
import image1 from '../assets/images/slide1.png'; 
import image2 from '../assets/images/slide2.png';
import image3 from '../assets/images/slide3.jpg';
import service1 from '../assets/images/service-1.png';
import service2 from '../assets/images/service-2.png';
import service3 from '../assets/images/service-3.png';
import service4 from '../assets/images/service-4.png';
import service5 from '../assets/images/service-5.png';
import service6 from '../assets/images/service-6.png';
import service7 from '../assets/images/service-7.png';
import service8 from '../assets/images/service-8.png';
import ourCSR1 from '../assets/images/ourCSR1.webp';
import ourCSR2 from '../assets/images/ourCSR2.webp';
import ourCSR3 from '../assets/images/ourCSR3.webp';
import ourCSR4 from '../assets/images/ourCSR4.webp';
import hero_logo from '../assets/images/hero_logo.svg';
import { LanguageContext } from '../contexts/LanguageContext'; // Import the LanguageContext
import HighlightsCarousel from '../components/HighlightsCarousel';
import { useHistory } from 'react-router-dom'; // Import useHistory for navigation

const Home = () => {
    const { t } = useContext(LanguageContext); // Access translations

    const [articles, setArticles] = useState([]);

    const history = useHistory(); // Initialize useHistory for navigation

    const handleContactClick = () => {
        history.push('/contact-us');
    };

    const handleExploreClick = () => {
        history.push('/about-us');
    }

    const handleLearnMoreClick = () => {
        history.push('/service');
    }

    const handleReadMoreClick = () => {
        history.push('/our-csr');
    }

    const handleViewAllClick = () => {
        history.push('/careers');  
    }

    useEffect(() => {
    axios.get('https://my-strapi-cms-5r1k.onrender.com/api/news-articles?populate=*')
        .then((res) => {
        setArticles(res.data.data);
        })
        .catch((err) => console.error('Error fetching articles:', err));
    }, []);

    const carouselSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        fade: true, // Enables fade effect
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
    };

    return (
        <div className="home">
            {/* Existing sections */}
            <section className="section-1">
                <div className="content">
                    <h1>
                        <span className="highlight">{t.home_section_1_highlight}</span> {t.home_section_1_opening} <span className="highlight">#3S</span>
                    </h1>
                    <p className="description">
                    {t.home_section_1_description}
                    </p>
                    <div className="buttons">
                        <button className="btn contact-us" onClick={handleContactClick}>{t.home_section_1_btn_1}</button>
                        <button className="btn explore" onClick={handleExploreClick}>{t.home_section_1_btn_2}</button>
                    </div>
                </div>
                <div className="image-container">
                    <Slider {...carouselSettings}>
                        <div>
                            <img src={image1} alt="Slide 1" />
                        </div>
                        <div>
                            <img src={image2} alt="Slide 2" />
                        </div>
                        <div>
                            <img src={image3} alt="Slide 3" />
                        </div>
                    </Slider>
                </div>
            </section>
            <section className="section-3">
                <h2>
                    <span className="highlight">{t.home_section_3_highlight}</span> {t.home_section_3_opening}
                </h2>
                <p className="opening">{t.home_section_3_description}</p>
                <div className="tiles">
                    <div className="tile">
                        <img src={ourCSR1} alt="Resilience" />
                        <h3>{t.resilience}</h3>
                        <p>{t.resilience_description}</p>
                    </div>
                    <div className="tile">
                        <img src={ourCSR2} alt="Innovation" />
                        <h3>{t.innovation}</h3>
                        <p>{t.innovation_description}</p>
                    </div>
                    <div className="tile">
                        <img src={ourCSR3} alt="Safety" />
                        <h3>{t.safety}</h3>
                        <p>{t.safety_description}</p>
                    </div>
                    <div className="tile">
                        <img src={ourCSR4} alt="Excellence" />
                        <h3>{t.excellence}</h3>
                        <p>{t.excellence_description}</p>
                    </div>
                </div>
                <div className="button-container">
                    <button className="btn read-more" onClick={handleReadMoreClick}>{t.home_section_3_btn}</button>
                </div>
            </section>
            <section className="section-2">
                <div className="services-grid">
                    {[
                    {
                        icon: service1,
                        title: t.security_guarding,
                        description: t.security_guarding_description,
                    },
                    {
                        icon: service2,
                        title: t.security_consulting,
                        description: t.security_consulting_description,
                    },
                    {
                        icon: service3,
                        title: t.elite_security,
                        description: t.elite_security_description,
                    },
                    {
                        icon: service4,
                        title: t.electronic,
                        description: t.electronic_description,
                    },
                    {
                        icon: service5,
                        title: t.k9,
                        description: t.k9_description,
                    },
                    {
                        icon: service6,
                        title: t.escort,
                        description: t.escort_description,
                    },
                    {
                        icon: service7,
                        title: t.cybersecurity,
                        description: t.cyber_description,
                    },
                    {
                        icon: service8,
                        title: t.airport,
                        description: t.airport_description,
                    },
                    ].map((service, index) => (
                    <div key={index} className="service-tile">
                        <img src={service.icon} alt={service.title} className="service-icon" />
                        <h3>{service.title}</h3>
                        <p>{service.description}</p>
                        {/* <button className="service-btn">{t.home_section_2_service_btn}</button> */}
                    </div>
                    ))}
                </div>
                <div className="content">
                    <img src={hero_logo} className="service-logo"/>
                    <h2>
                        <span className="highlight">{t.home_section_2_highlight}</span>{t.home_section_2_opening}
                    </h2>
                    <p className="description">
                        {t.home_section_2_description}
                    </p>
                    <div className="buttons">
                        <button className="btn learn-more" onClick={handleLearnMoreClick}>{t.home_section_2_btn}</button>
                    </div>
                </div>
            </section>
            <section className="section-4">
                <h2>
                    <span className="highlight">{t.home_section_4_highlight}</span> {t.home_section_4_opening}
                </h2>
                <p className="opening">{t.home_section_4_description}</p>
                <div className="tiles">
                    <div className="tile">
                        <h3>{t.approach}</h3>
                        <p>{t.approach_description}</p>
                    </div>
                    <div className="tile">
                        <h3>{t.sustainability}</h3>
                        <p>{t.sustainability_description}</p>
                    </div>
                    <div className="tile">
                        <h3>{t.employees}</h3>
                        <p>{t.employees_description}</p>
                    </div>
                </div>
                <div className="button-container">
                    <button className="btn read-more" onClick={handleReadMoreClick}>{t.home_section_4_btn}</button>
                </div>
            </section>
            <section className="section-5">
                <div className="tile left-tile with-background">
                    <h2>{t.home_section_5_career}</h2>
                    <p>{t.home_section_5_opening}<span className="highlight">{t.home_section_5_highlight}</span> {t.home_section_5_description}</p>
                    <h3>{t.home_section_5_follow}</h3>
                    <div className="social-icons">
                        <img src={linkedinIcon} alt="LinkedIn" />
                        <img src={facebookIcon} alt="Facebook" />
                        <img src={twitterIcon} alt="Twitter" />
                    </div>
                </div>
                <div className="tile right-tile">
                    <h2>{t.home_section_5_team}</h2>
                    <p><a href="#">{t.job_board}</a></p>
                    <h3>{t.latest_vacancies}</h3>
                    <ul className="vacancies-list">
                        <li>
                            <span className="job-title">{t.area_security_officer}</span><br />
                            <span className="job-location">{t.location}</span>
                        </li>
                        <li>
                            <span className="job-title">{t.area_security_officer}</span><br />
                            <span className="job-location">{t.location}</span>
                        </li>
                        <li>
                            <span className="job-title">{t.area_security_officer}</span><br />
                            <span className="job-location">{t.location}</span>
                        </li>
                    </ul>
                    <button className="btn view-all" onClick={handleViewAllClick}>{t.home_section_5_btn}</button>
                </div>
            </section>
            <div className="news-section">
                <p>{t.our_blog}</p>
                <h2>
                    <span className="highlight">{t.news_section_highlight} </span>{t.news_section_opening}
                </h2>
                <p className="opening">{t.news_section_description}</p>
                <HighlightsCarousel />
            </div>
        </div>
    );
};

export default Home;